import React from 'react';

const ModalMenuSecondary = () => {
    return (
        <div className="modal-text order-1 order-sm-0 order-md-0 order-lg-0 order-xl-0">
            <p>320 Decker Drive <br/>TX 75062 <br/>Irving</p>

            <p>
                <a href="tel:+43253312523">+1 914 265 5072</a><br/>
                <a href="mailto:info@domain.com">hello@z3info.com</a>
            </p>
        </div>
    );
};

export default ModalMenuSecondary;
